/**
 * @generated SignedSource<<d774f6ede040bd603f24d42a932908b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImageMultiSkuOverlay_sku$data = {
  readonly ImageMultiSkuOverlayImageSrc: string | null;
  readonly " $fragmentType": "ImageMultiSkuOverlay_sku";
};
export type ImageMultiSkuOverlay_sku$key = {
  readonly " $data"?: ImageMultiSkuOverlay_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "large",
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImageMultiSkuOverlay_sku",
  "selections": [
    {
      "alias": "ImageMultiSkuOverlayImageSrc",
      "args": [
        {
          "kind": "Variable",
          "name": "size",
          "variableName": "imageSize"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": null
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "4880ed8c687425880383ba6552639683";

export default node;
